import api from "./api"; // axios instance با توکن

/**
 * Store: get users list
 */
export async function getUsers(params = {}) {
  const { data } = await api.get("/store-panel/users", { params });
  return data;
}

export const getStoreProfile = async () => {
  const res = await api.get("/store-panel/me");
  return res.data;
};

export const updateStoreProfile = async (data) => {
  const res = await api.put("/store/me", data);
  return res.data;
};

export const getSalesSummary = async () => {
  const res = await api.get("/store-panel/sales-summary");
  return res.data;
};

export const getWalletSummary = async () => {
  const res = await api.get("/store-panel/wallet");
  return res.data;
};

export const getWalletTransactions = async () => {
  const res = await api.get("/store-panel/wallet/transactions");
  return res.data;
};

// لیست درخواست‌ها
export const getCreditRequests = async () => {
  const res = await api.get("/store-panel/credit-requests");
  return res.data;
};

// ایجاد درخواست جدید
export const createCreditRequest = async (data) => {
  const res = await api.post("/store-panel/credit-requests", data);
  return res.data;
};

export async function updateCreditRequest(id, payload) {
  // payload: { userId, walletAmount, creditAmount, description }
  const { data } = await api.patch(`/store-panel/credit-requests/${id}`, payload);
  return data;
}

export async function rejectCreditRequestStatus(id, body) {
  const { data } = await api.post(`/store-panel/credit-requests/${id}/reject`, body);
  return data;
}

export async function updateCreditRequestStatus(id, body) {
  const { data } = await api.post(`/store-panel/credit-requests/${id}/verify`, body);
  return data;
}



